// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__343bm","productName":"Table_productName__2eqsR"};